import { Injectable } from '@angular/core';

/**
 * Service to store get and remove object in localstorage
 */
@Injectable({
  providedIn: 'root'
})
export class StorageService {
  /**
   * @ignore
   */
  constructor() { }

  /**
   * Save object
   * @param key Unique key
   * @param value Value to save
   */
  storeObject(key: string, value: any) {
    try {
      window.localStorage[key] = JSON.stringify(value);
    } catch (e) { }
  }

  /**
   * Retrive object
   * @param key Unique key
   */
  getStoredObject(key: string): any {
    try {
      return JSON.parse(window.localStorage[key] || null);
    } catch (e) {
      return null;
    }
  }

  /**
   * Remove object
   * @param key Unique key
   */
  removeObject(key: string) {
    try {
      window.localStorage.removeItem(key);
    } catch (e) { }
  }

}
